import React, { useEffect, useState } from 'react';
import { get, getDatabase, ref } from 'firebase/database';
import './LoginPage.css';

/**
 * The two-pane frame of the pages reached before signing in: the Molnfastigheter
 * logo above the page's own content on the left, the customer's background image
 * and logo (publicSettings/loginPage) on the right. Shared by the login page and
 * the set-password page so both read as the same place.
 */
const LoginLayout = ({ children }: { children: React.ReactNode }) => {
    const [backgroundImageUrl, setBackgroundImageUrl] = useState<string | null>(null);
    const [customerLogoUrl, setCustomerLogoUrl] = useState<string | null>(null);
    const [configLoading, setConfigLoading] = useState(true);

    // Load public login page configuration
    useEffect(() => {
        const loadLoginPageConfig = async () => {
            try {
                const snapshot = await get(ref(getDatabase(), 'publicSettings/loginPage'));
                if (snapshot.exists()) {
                    const config = snapshot.val();
                    setBackgroundImageUrl(config.backgroundImageUrl || null);
                    setCustomerLogoUrl(config.customerLogoUrl || null);
                }
            } catch (error) {
                console.error('Error loading login page config:', error);
                // Fail silently - use defaults
            } finally {
                setConfigLoading(false);
            }
        };

        loadLoginPageConfig();
    }, []);

    return (
        <div className="login-page">
            <div className="login-left">
                <div className="logo-section">
                    <img
                        src="/Images/molnfastigheter_logo_white.png"
                        alt="Molnfastigheter"
                        className="logo-image"
                    />
                </div>
                {children}
            </div>

            <div className="login-right"
                 style={{
                     backgroundImage: backgroundImageUrl ? `url('${backgroundImageUrl}')` : 'none',
                     backgroundColor: backgroundImageUrl ? 'transparent' : 'white',
                     position: 'relative',
                     display: 'flex',
                     alignItems: 'center',
                     justifyContent: 'center'
                 }}>
                {!configLoading && !backgroundImageUrl && (
                    <div style={{
                        color: '#999',
                        fontSize: '16px',
                        textAlign: 'center',
                        userSelect: 'none'
                    }}>
                        Ingen bakgrundsbild vald
                    </div>
                )}

                {customerLogoUrl && (
                    <div
                        style={{
                            position: 'absolute',
                            bottom: '26px',
                            right: '26px',
                            backgroundColor: 'white',
                            padding: '12px 20px',
                            borderRadius: '8px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                        }}
                    >
                        <img
                            src={customerLogoUrl}
                            alt="Logo"
                            style={{
                                maxWidth: '200px',
                                maxHeight: '100px',
                                height: 'auto',
                                width: 'auto',
                                display: 'block'
                            }}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default LoginLayout;
